(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sufi-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('.sufi-mobile-nav a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.sufi-mobile-nav details[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  } catch(e) { console.error(e); }
})();

})();
